import { render } from "./SearchResultsModal.vue?vue&type=template&id=608b098e&scoped=true"
import script from "./SearchResultsModal.vue?vue&type=script&lang=js"
export * from "./SearchResultsModal.vue?vue&type=script&lang=js"

import "./SearchResultsModal.vue?vue&type=style&index=0&id=608b098e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608b098e"]])

export default __exports__